import React from "react";
import { SelectItem } from "../../../Components/Items";

function SelectorModeloReporte({ modelos, value, onChange }) {
  return (
    <SelectItem
      value={value}
      onChange={onChange}
      style={{ width: 220 }}
      placeholder="Elige un modelo"
      options={modelos.map((m) => ({ value: m.key, label: m.label }))}
    />
  );
}

export default SelectorModeloReporte;
